var render, staticRenderFns
import script from "./PostListItem.vue?vue&type=script&lang=tsx&"
export * from "./PostListItem.vue?vue&type=script&lang=tsx&"
import style0 from "./PostListItem.vue?vue&type=style&index=0&id=443f9a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f9a18",
  null
  
)

export default component.exports